import { COOKIE_KEYS } from 'Consts/cookies.enum'
import { LANGUAGES_OPTIONS, LanguagesTypes } from 'Types/Languages'
import i18n from 'Lib/i18n'
import { COOKIE_OPTIONS, CookieHelper } from 'Utils/cookieHelper'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const useSetLanguage = () => {
  const { setCookie, getCookie } = CookieHelper()
  const { setLanguage: setUserLanguage } = useUserStore()

  const setLanguage = async (languageParam: LanguagesTypes | undefined) => {
    if (languageParam) setCookie(COOKIE_KEYS.LANGUAGE, languageParam, COOKIE_OPTIONS)

    const language =
      languageParam || (getCookie(COOKIE_KEYS.LANGUAGE) as LanguagesTypes) || LANGUAGES_OPTIONS.EN
    setUserLanguage(language)

    await i18n.changeLanguage(language)
  }

  return { setLanguage }
}
